
import { mixin as clickaway } from 'vue-clickaway';
import { mapActions, mapGetters } from 'vuex';
import LoadingSpinner from '@/components/loaders/LoadingSpinner.vue';
import FixCard from '../../assets/icons/fixcard.svg';
import TimeIcon from '../../assets/icons/time.svg';
import PresetStatus from '../class/PresetStatus';

export default {
  components: {
    TimeIcon, FixCard, LoadingSpinner,
  },
  mixins: [clickaway],
  props: {
    preset: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      default: 'standard',
    },
    hidePin: {
      type: Boolean,
      default: false,
    },
    animation: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['contextMenuShow'],
  data: () => ({
    showAnimation: false,
    blocked: false,
  }),
  computed: {
    ...mapGetters({
      forceLocalLoadingCardPlaceId: 'system/getForceLocalLoadingCardPlaceId',
      getTranslations: 'localization/getTranslations',
    }),
    presetStatus() {
      return new PresetStatus(this.preset);
    },
  },
  watch: {
    forceLocalLoadingCardPlaceId: {
      handler(newValue) {
        if (newValue && newValue === this.preset.id) {
          this.showAnimation = true;
          this.blocked = true;
          setTimeout(() => {
            this.showAnimation = false;
            this.blocked = false;
            this.$store.commit('system/FORCE_LOCAL_LOADING_CARD_PLACE_ID', null);
          }, 2000);
        }
      },
    },
  },
  mounted() {
    if (this.animation && this.$refs.preset) {
      setTimeout(() => {
        if (this.$refs.preset) {
          this.$refs.preset.style.opacity = 1;
        }
      }, 300);
    }
    this.$refs.preset.addEventListener('long-press', (e) => {
      this.$emit('contextMenuShow', [e, this.preset]);
    });
  },
  beforeDestroy() {
    this.$refs.preset.removeEventListener('long-press', (e) => {
      this.$emit('contextMenuShow', [e, this.preset]);
    });
  },
  methods: {
    ...mapActions({
      setPresetStatus: 'buildingDashboard/setPresetStatus',
    }),
    async clickHandler() {
      if (!this.blocked && !this.showAnimation) {
        this.blocked = true;
        await this.setPresetStatus({
          id: this.preset.id,
          isOn: this.preset.isOn,
          table: 'placePresets',
        });
        this.blocked = false;
      }
    },
  },
};
